<template>
    <div>

        <FileManager @fileSelected="getImageSelected"></FileManager>

        <transition name="fade" mode="out-in">
        
            <div class="editor-area__section editor-area__empty" 
                 v-if="selectedSectionToEdit === ''" 
                 key="empty"
            >
                <p class="section__title">Selecione a seção que deseja editar.</p>
            </div>

            <div class="editor-area__section editor-area__section--colors" 
                 v-else-if="selectedSectionToEdit === 'colors'" 
                 key="colors-section"
            >
                <h3 class="section__title">Cores</h3>
                <div class="section__inputs-container">

                    <CInput 
                        :type="'color'" 
                        :label="'Cor primária:'"
                        :for_id="'primary-color'"
                        :value.sync="data.primaryColor"
                    />

                    <CInput 
                        :type="'color'" 
                        :label="'Cor secundária:'"
                        :for_id="'secondary-color'"
                        :value.sync="data.secondaryColor"
                    />

                    <CInput 
                        :type="'color'" 
                        :label="'Cor terciária:'"
                        :for_id="'terciary-color'"
                        :value.sync="data.tertiaryColor"
                    />
                </div>

                </div>

                <div class="editor-area__section editor-area__section--banner" 
                     v-else-if="selectedSectionToEdit === 'bannerSection'" 
                     key="banner-section"
                >
                    <h3 class="section__title">Imagem destaque</h3>
                    <div class="section__inputs-container">

                    <div class="input-item">
                        <label class="input-item__label">Imagem:</label>
                        <button @click="setFieldToPutImage" 
                                id="banner-image-btn" 
                                class="button-default" 
                                data-toggle="modal" 
                                data-target="#modal-filemanager"
                        >
                            Abrir arquivos 
                        </button>
                    </div>

                    <CInput 
                        :type="'url'" 
                        :label="'Texto alternativo:'"
                        :for_id="'banner-image-alt'"
                        :value.sync="data.bannerSection.image.alt"
                    />
                </div>
            </div>
                            
            <div class="editor-area__section editor-area__section--description" 
                 v-else-if="selectedSectionToEdit === 'descriptionSection'" 
                 key="description-section"
            >
                <h3 class="section__title">Descrição</h3>
                <div class="section__inputs-container">
                
                    <CInput 
                        :type="'text'" 
                        :label="'Título:'"
                        :description="'*Breve descrição da imagem. Esse texto será exibido se a imagem não puder ser exibida.'"
                        :for_id="'description-title'"
                        :value.sync="data.descriptionSection.title"
                    />
                    <CInput 
                        :type="'textArea'" 
                        :label="'Texto:'"
                        :for_id="'description-text'"
                        :value.sync="data.descriptionSection.paragraph"
                    />
                    <CInput 
                        :type="'text'" 
                        :label="'Texto do botão:'"
                        :description="'*Alguns servidores de e-mails podem não reproduzir exatamente o layout do botão.'"
                        :for_id="'description-button-text'"
                        :value.sync="data.descriptionSection.button.text"
                    />
                    <CInput 
                        :type="'url'" 
                        :label="'Link do botão:'"
                        :for_id="'description-button-link'"
                        :value.sync="data.descriptionSection.button.link"
                    />
                </div>
            </div>
            
             
            <div class="editor-area__section editor-area__section--description" 
                 v-else-if="selectedSectionToEdit === 'productsListSection'" 
                 key="products-list"
            >           
                <h3 class="section__title">Lista de produtos</h3>
                <div class="section__inputs-container">

                    <CInput 
                        :type="'text'" 
                        :label="'Título:'"
                        :for_id="'products-list-title'"
                        :value.sync="data.productsListSection.title"
                    />
                            
                    <div class="input-item" v-for="product in data.productsListSection.productsList" :key="product.id">
                        <div class="collapse-title" :id="product.id" @click="openProductItemInputs">
                            <h4 :id="product.id" class="product-item__title">{{`Produto ${product.id}`}}</h4>
                            <ExpandIcon :id="product.id" :class="data.productsListSection.productsList[product.id - 1].isOpen ? 'isOpen' : 'isClosed'" />
                        </div>
                        <transition name="expand">
                            <div class="collapse-content" v-show="data.productsListSection.productsList[product.id - 1].isOpen">

                                <div class="input-item">
                                    <label class="input-item__label">Imagem:</label>
                                    <button @click="setFieldToPutImage" 
                                            :id="`product-${product.id}-image-btn`" 
                                            class="button-default" 
                                            data-toggle="modal" 
                                            data-target="#modal-filemanager"
                                    >
                                        Abrir arquivos
                                    </button>
                                </div>

                                <CInput 
                                    :type="'text'" 
                                    :label="'Nome:'"
                                    :for_id="'input-text-products-list-name'"
                                    :productItem="true"
                                    :value.sync="data.productsListSection.productsList[product.id - 1].productData.name"
                                />

                                <CInput 
                                    :type="'text'" 
                                    :label="'Código:'"
                                    :for_id="'input-text-products-list-code'"
                                    :productItem="true"
                                    :value.sync="data.productsListSection.productsList[product.id - 1].productData.code"
                                />

                                <CInput 
                                    :type="'textArea'" 
                                    :label="'Descrição:'"
                                    :for_id="'input-text-products-list-description'"
                                    :rows="4"
                                    :productItem="true"
                                    :value.sync="data.productsListSection.productsList[product.id - 1].productData.description"
                                />

                                <CInput 
                                    :type="'url'" 
                                    :label="'Link:'"
                                    :for_id="'input-text-products-list-link'"
                                    :productItem="true"
                                    :value.sync="data.productsListSection.productsList[product.id - 1].productData.link.url"
                                />

                            </div>
                        </transition>
                    </div>
                    <div class="products-buttons-container">
                        <button 
                            class="button-default add-product-button" 
                            @click="addProduct" 
                            v-if="data.productsListSection.productsList.length < 5">
                            Novo produto
                        </button>
                        <button 
                            class="button-default remove-product-button" 
                            @click="removeProduct" 
                            v-if="data.productsListSection.productsList.length > 1">
                            Remover
                        </button>
                    </div>
                </div>
            </div>      
        </transition>
    </div>
</template>

<script>
import ExpandIcon from '../../../icons/expand-icon.vue'
import CInput from '../../../inputs/c-input.vue'
import FileManager from '../../../../../../components/c-atlas-filemanager.vue'
import $ from "jquery";

export default {
    name: 'CEditorLayout1',
    components: { ExpandIcon, CInput, FileManager },
    props: {
        selectedSectionToEdit: String,
        data: Object,
    },
    data() {
        return {
            html: null,
            componentData: this.data,
            imageSelected: '',
            fieldToPutImage: '',
        }    
    },
    watch: {
        componentData() {
            this.$emitData()
        }
    },
    methods: {
        setFieldToPutImage(event) {
            if (event.target.id === 'banner-image-btn') {
                this.fieldToPutImage = 'banner-image'
            } else {
                this.data.productsListSection.productsList.forEach(product => {
                    if (event.target.id === `product-${product.id}-image-btn`) {
                        this.fieldToPutImage = `product-${product.id}-image`
                    }
                });
            }
        },
        getImageSelected (value) {
            this.imageSelected = value;
            console.log('image selected', value);

            if (this.fieldToPutImage === 'banner-image') {
                this.data.bannerSection.image.url = value.url
            } else {
                this.data.productsListSection.productsList.forEach(product => {

                    if (this.fieldToPutImage === `product-${product.id}-image`) {
                        this.data.productsListSection.productsList[product.id - 1].image.url = value.url
                    }
                });
            }
            document.getElementById('close-modal').click();
            console.log('imageToSet', this.imageToSet)
        },
        emitData() {
            this.$emit('update:data', this.componentData)
        },
        openProductItemInputs(event) {
            const index = event.target.id - 1
            this.data.productsListSection.productsList[index].isOpen = !this.data.productsListSection.productsList[index].isOpen
        },
        addProduct() {
            const idNewProduct = this.data.productsListSection.productsList.length + 1
            let newProduct =  {
                        id: idNewProduct,
                        isOpen: false,
                        image: {
                            url: _PUBLIC_PATH + "/images/news-personalizada/img-produto.png",
                            alt: 'Imagem do produto'
                        },
                        productData: {
                            name: 'Lixadeira Roto-Orbital',
                            code: 'AT1701',
                            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec interdum rutrum nunc, id faucibus erat ultrices in.',
                            link: {
                                text: 'Saiba +',
                                url: 'http://www.google.com'
                            }
                        }
                    }
            if(this.data.productsListSection.productsList.length < 5) {
                this.data.productsListSection.productsList.push(newProduct)
            } 
        },
        removeProduct() {
            if (this.data.productsListSection.productsList.length > 1) {
                this.data.productsListSection.productsList.pop()
            }
        }
    }
}
</script>

<style src="../../style.scss" lang="scss" scoped></style>